import {
  mockTabDetailsTableHeadings,
  mockTabDetailsTableData,
} from "../mockData/Tableheadings";

const MOCK_DELAY = 1000;

/**
 * Simulate API delay for mock data
 * @param {*} data - Data to return
 * @param {number} delay - Delay in milliseconds
 * @returns {Promise<*>} Resolved promise with data
 */
const simulateApiCall = (data, delay = MOCK_DELAY) =>
  new Promise((resolve) => setTimeout(() => resolve(data), delay));

/**
 * Get settings data for a tab category
 * @param {string} tabCategory - The tab category identifier
 * @returns {Promise<Object|undefined>} Settings data or undefined
 */
export const getSettingsData = (tabCategory) => {
  const data = mockTabDetailsTableHeadings[tabCategory];
  return data ? simulateApiCall(data) : Promise.resolve(undefined);
};

/**
 * Get table data for a tab category
 * @param {string} tabCategory - The tab category identifier
 * @returns {Promise<Object|undefined>} Table data or undefined
 */
export const getTableData = (tabCategory) => {
  const data = mockTabDetailsTableData[tabCategory];
  return data ? simulateApiCall(data) : Promise.resolve(undefined);
};
